import React, { useEffect } from 'react';
import { Icon } from 'rsuite';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash/fp';
import styled from 'styled-components';
import { fetchGuestRelationship } from '../../../redux/sagas/routines';
import {
  getRelationshipForId,
  getFetching
} from '../../../redux/Guest/selectors/components/relationship';
import pagePathToUrl from '../../../helpers/pagePathToUrl';
import formatFullName from '../../../helpers/formatFullName';
import { guestsViewPath } from '../../../routes/Paths';
import { GuestRelationHeading } from '../ViewElements';

const Wrapper = styled.div`
  display: inline-block;
  vertical-align: top;
`;

const Relationship = ({ guestId: id, showHeading, ...props }) => {
  const dispatch = useDispatch();
  const isFetching = useSelector(getFetching);
  const guest = useSelector(state => getRelationshipForId(state, id));
  const fullName = formatFullName([
    get('firstname', guest),
    get('lastname', guest)
  ]);
  const viewUrl = pagePathToUrl(guestsViewPath, { id, section: 'primary' });

  useEffect(() => {
    if (get('id', guest) === id) return;
    dispatch(fetchGuestRelationship(id));
  }, []);

  if (!guest) return '';

  return (
    <Wrapper {...props}>
      {showHeading && (
        <GuestRelationHeading>Primary Record</GuestRelationHeading>
      )}
      <a target="_blank" rel="noopener noreferrer" href={viewUrl}>
        {isFetching ? 'loading...' : fullName} <Icon icon="external-link" />
      </a>
    </Wrapper>
  );
};

Relationship.propTypes = {
  guestId: PropTypes.number.isRequired,
  showHeading: PropTypes.bool
};

Relationship.defaultProps = {
  showHeading: false
};

export default Relationship;
